import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=58bb82a3"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58bb82a3')) {
      api.createRecord('58bb82a3', component.options)
    } else {
      api.reload('58bb82a3', component.options)
    }
    module.hot.accept("./SidebarItem.vue?vue&type=template&id=58bb82a3", function () {
      api.rerender('58bb82a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/ezpay/Sidebar/SidebarItem.vue"
export default component.exports